import Flow from './components/Flow';
import './App.css';

function App() {
  return (
    <div className="App">
      <div style={{ width: '100vw', height: '100vh' }}>
        <Flow />
      </div>
    </div>
  );
}

export default App;